<template>
  <div class="container">
      <!--scheduler class="left-container" :events="events" @event-updated="logEventUpdate" v-if="events" / -->
    <h2 class="subtitle">
      Planning
    </h2>
    <v-calendar
      ref="calendar"
      v-model="focus"
      color="primary"
      type="week"
      category-show-all
      :weekdays="[1, 2, 3, 4, 5, 6, 0]"
      :categories="categories"
      :events="events"
      :event-color="getEventColor"
      @click:time="clickOnTime"
      @click:event="showEvent"
    >
      <template #event="{ event }">
          <div
            class="v-event-draggable pa-1"
          >
            <div>{{displayHour(event)}}</div>
            <div><strong>Bays: #{{event.bays}}</strong> / {{event.name}}</div><br>
          </div>
        </template>
    </v-calendar>
    <v-dialog v-model="dialog" max-width=860>
      <v-card>
        <v-card-title>Add Slot</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
          <v-row>
            <v-col>
              <v-select :items="types" v-model=slot.type label="Type"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select :items="bays" v-model=slot.bays item-text=name item-value=id label="Bay"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select :items="days" v-model=slot.day label="Day"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field v-model="slot.start" label="Start Hour" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field v-model="slot.end" label="End Hour" />
            </v-col>
          </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">Cancel</v-btn>
          <v-spacer />
          <v-btn text @click="doDelete">Delete</v-btn>
          <v-btn text @click="submitEvent">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
/*import Scheduler from '@components/scheduler/Scheduler.vue'*/
export default {
  components: {
    //Scheduler
  },
  data: () => ({
    types:[
      {value:'standard', text:'Standard'},
      {value:'premium', text:'Premium'},
      {value:'reserved', text:'Reserved'},
    ],
    /*bays:[
      {value:1, text:'Bay 1'},
      {value:2, text:'Bay 2'},
    ],*/
    days:[
      {value:1, text:'Monday'},
      {value:2, text:'Tuesday'},
      {value:3, text:'Wednesday'},
      {value:4, text:'Thursday'},
      {value:5, text:'Friday'},
      {value:6, text:'Saturday'},
      {value:7, text:'Sunday'},
    ],
    focus:'',
    dialog:false,
    messages: [],
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
    categories: ['Bay 1', 'Bay 2'],
    slot:{
      type:null,
      bays:null,
      day:null,
      start:null,
      end:null
    },
    emptySlot:{
      type:null,
      bays:null,
      day:null,
      start:null,
      end:null
    }
  }),
  computed:{
    ...mapGetters("scheduler", ["events"]),
    ...mapGetters("xperience", ["bays"])
  },
  mounted(){
    this.getEvents();
    this.getBays();
  },
  methods: {
    ...mapActions("scheduler",{getEvents:"list", addEvent:"create",updateEvent:"update",deleteEvent:"delete"}),
    ...mapActions("xperience", {getBays:'getBays'}),

    logEventUpdate (id, mode, ev) {
      if(ev){
        if(mode == 'inserted'){
          this.addEvent(ev);
        }
        if(mode == 'updated'){
          this.updateEvent(ev);
        }
        if(mode == 'deleted'){
          this.deleteEvent(ev);
        }
      }
    },
    getEventColor (event) {
      return event.color
    },
    clickOnTime(day) {
      const ROUNDING = 5 * 60 * 1000 /* ms */
      let start = moment(day.date + ' ' + day.time)
      start = moment(Math.ceil(+start / ROUNDING) * ROUNDING)
      let end = moment(start).add(60,"minute")
      this.slot.start= start.format("HH:mm")
      this.slot.end= end.format("HH:mm")
      this.slot.day = start.isoWeekday()
      this.dialog=true;
    },
    doDelete() {
      this.deleteEvent(this.slot)
        .then(() => {
          this.getEvents();
        })
        .finally(()=>{
          this.close();
        })
    },
    submitEvent(){
      if(this.slot.id){
        this.updateEvent(this.slot)
        .then(() => {
          this.getEvents();
        })
        .finally(()=>{
          this.close();
        })
      }else{
        this.addEvent(this.slot)
        .then(() => {
          this.getEvents();
        })
        .finally(()=>{
          this.close();
        })
      }
      
    },
    showEvent({ nativeEvent, event }) {
      nativeEvent.preventDefault();
      nativeEvent.stopPropagation();
      this.slot = Object.assign({},event);
      this.slot.start = moment(this.slot.start).format("HH:mm");
      this.slot.end = moment(this.slot.end).format("HH:mm");
      this.dialog=true;
    },
    close(){
      this.slot = Object.assign({}, this.emptySlot);
      this.dialog=false
    },
    
    displayHour(event){
      return moment(event.start).format("HH:mm") + " - " + moment(event.end).format("HH:mm")
    }
  }

}
</script>

<style>
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
  }
 
  .container {
    height: 100%;
    width: 100%;
  }
 
  .left-container {
    overflow: hidden;
    position: relative;
    height: 100vh;
    display: inline-block;
    width: 100%;
  }
.scheduler-messages {
    list-style-type: none;
    height: 50%;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-left: 5px;
  }
 
  .scheduler-messages > .scheduler-message {
    background-color: #f4f4f4;
    box-shadow:inset 5px 0 #d69000;
    font-family: Geneva, Arial, Helvetica, sans-serif;
    font-size: 14px;
    margin: 5px 0;
    padding: 8px 0 8px 10px;
  }
 
</style>